import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserModel } from 'src/app/models/authentication/user.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { CompanyModel } from 'src/app/models/management/company.model';
import { GeneralParameterModel } from 'src/app/models/management/general-parameter.model';

@Injectable({
  providedIn: 'root'
})
export class UserAuthenticatedService {
  // BehaviorSubject :mantiene el último valor emitido y lo proporciona a cualquier nuevo suscriptor
  private userModel = new BehaviorSubject<UserModel>(new UserModel());
  private branchModel = new BehaviorSubject<BranchModel>(new BranchModel());
  private companyModel = new BehaviorSubject<CompanyModel>(new CompanyModel());
  private listGeneralParameterModel = new BehaviorSubject<Array<GeneralParameterModel>>(new Array<GeneralParameterModel>());

  //asObservable se utiliza para exponer el sujeto (userObservable) como un observable sin permitir que los suscriptores emitan valores mediante el método next.
  userObservable = this.userModel.asObservable();
  branchObservable = this.branchModel.asObservable();
  companyObservable = this.companyModel.asObservable();
  generalParameterObservable = this.listGeneralParameterModel.asObservable();

  constructor() { }
  assignUser(userModel: UserModel) {
    //Cuando se llama al método next(valor), se emite ese valor y se convierte en el valor actual del BehaviorSubject
    this.userModel.next(userModel);
  }

  assignCompany(companyModel: CompanyModel) {
    //Cuando se llama al método next(valor), se emite ese valor y se convierte en el valor actual del BehaviorSubject
    this.companyModel.next(companyModel);
  }

  assignFirstBranchByUser(branchModel: BranchModel) {
    //Cuando se llama al método next(valor), se emite ese valor y se convierte en el valor actual del BehaviorSubject
    this.branchModel.next(branchModel);
  }

  assignListGeneralParametersByCompany(ListGeneralParameterModel: Array<GeneralParameterModel>) {
    //Cuando se llama al método next(valor), se emite ese valor y se convierte en el valor actual del BehaviorSubject
    this.listGeneralParameterModel.next(ListGeneralParameterModel);
  }
}
